<template>
  <div class="map-item-wrapper">
    <div class="map-item-container" style="display: flex; align-items: start; margin: 0 10px;">
      <div class="map-thumb-wrapper" style="flex: 0 0; padding-right: 10px;">
        <img :src="mapThumbnailUrl" class="map-thumb" />
      </div>

      <div class="card-wrap" style="flex: 1;">
        <div class="card-title">
          <div class="map-name">
            <el-link @click="openMapDetail">
              <el-text>
                {{ map.name }}
              </el-text>
            </el-link>
          </div>

          <div class="author-wrap">
            <div class="author-left">
              <el-image
                :src="authorAvatar"
                class="round-img"
                v-if="authorAvatar"
              />
              <el-text size="small" truncated>
                <span class="secondary-text map-by">Map by</span>
                <a class="username-link" :href="authorUrl" target="_blank">{{
                  authorName
                }}</a>
              </el-text>
            </div>
          </div>
        </div>
        <div class="card-actions">
          <el-button link @click="toggMapVisibleOnEarth">
            <el-icon v-if="visible"><View /></el-icon>
            <el-icon v-else><Hide /></el-icon>
          </el-button>
          <el-button icon="Delete" link @click="deleteFromEarth" />
          <el-button icon="Refresh" link @click="clickRefreshMapOnEarth" />
          <el-button
            link
            @click="dropdownLayer"
            v-if="!isDatahubLayer && map.layers"
          >
            <el-icon>
              <ArrowDownBold v-if="showLayer" />
              <ArrowRightBold v-else />
            </el-icon>
          </el-button>
        </div>
      </div>
    </div>
    <el-card
      class="box-card"
      v-show="showLayer"
      shadow="never"
      v-if="!isDatahubLayer"
    >
      <div class="text item" v-for="(l, i) in map.layers" :key="i">
        <layer-item
          :vis-id="map.id"
          :layer="l"
          :show-search-btn="false"
          :show-refresh-btn="false"
          @toggleVisible="toggleMapLayer"
        ></layer-item>
      </div>
    </el-card>
    <KeepAlive>
      <map-detail
        ref="mapDetailRef"
        :map="map"
        :index="index"
        v-show="mapDetailVisible"
        @close="closeMapDetail"
      ></map-detail>
    </KeepAlive>
  </div>
</template>
<script>
import * as Visualization from '@/carto-node/models/visualization';
import { getCartoModels } from '@/carto-node/models/CoreModels';
import { authorUrlBy, authorAvatarBy, authorNameBy, mapThumbnailUrlBy } from "@/components/utils/map";
import LayerItem from '@/components/maps/LayerItem';
import MapDetail from '@/components/maps/MapDetail';
import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';
import { has } from 'lodash';

const { track } = useTrack();

export default {
  components: {
    LayerItem,
    MapDetail,
  },
  props: {
    index: Number,
    map: Object,
  },
  data() {
    return {
      showLayer: false,
      thumbnailWidth: 600,
      thumbnailHeight: 280,
      mapDetailVisible: false,
    };
  },
  computed: {
    authorName() {
      return authorNameBy(this.map);
    },

    authorUrl() {
      return authorUrlBy(this.map);
    },

    authorAvatar() {
      return authorAvatarBy(this.map);
    },

    visible() {
      return this.map.visible;
    },

    mapThumbnailUrl() {
      return mapThumbnailUrlBy(this.map, this.thumbnailWidth, this.thumbnailHeight);
    },
    
    earthLayer() {
      const earthLayer = Visualization.convert2EarthLayer(
        this.map,
        getCartoModels(),
        {
          width: this.thumbnailWidth,
          height: this.thumbnailHeight,
        },
      );
      if (!this.isDatahubLayer) {
        const tileUrl = Visualization.getMapTileUrlWithLayers(
          earthLayer.layerServiceInfo.url,
          this.visibleLayerIndexs,
        );
        earthLayer.layerServiceInfo.url = tileUrl;
      }
      return earthLayer;
    },

    visibleLayers() {
      const layers = this.$store.getters['maps/getVisibleLayers'](this.map.id);
      return layers || [];
    },

    visibleLayerIndexs() {
      return this.visibleLayers.map((l) => l.order);
    },

    //是否是datahub layer
    isDatahubLayer() {
      return this.map && has(this.map, 'layerServiceInfo');
    },

    vuexModule() {
      let module = 'maps';
      
      if (this.map.module) {
        return this.map.module;
      }
      if (this.isDatahubLayer) {
        module = 'datahubLayers';
      }

      return module;
    },
  },
  methods: {
    dropdownLayer() {
      this.showLayer = !this.showLayer;

      track(
        FunctionIdEnum.globalLayer_layers_expandSubLayers,
        EventTypeEnum.CLICK,
        {
          id: this.map.id,
        },
      );
    },
    deleteFromEarth() {
      this.$store.dispatch(`${this.vuexModule}/removeFromEarth`, this.map.id);
      this.delMap();

      track(
        FunctionIdEnum.globalLayer_layers_removeLayer,
        EventTypeEnum.CLICK,
        {
          id: this.map.id,
        },
      );
    },
    //删除已上球图层w
    delMap() {
      this.$EventBus.emit('globaluncheckedLayer', this.earthLayer);
    },

    //切换图层是否可见
    toggleMapLayer() {
      if (this.visible) {
        if (this.visibleLayers.length > 0) {
          this.refreshMapOnEarth();
        } else {
          this.$EventBus.emit('globalhideLayer', this.index);
        }
      }

      track(
        FunctionIdEnum.globalLayer_layers_toggleSubLayersVisible,
        EventTypeEnum.CLICK,
        {
          id: this.map.id,
        },
      );
    },

    //控制已上球地图是否可见
    toggMapVisibleOnEarth() {
      const visible = !this.visible;
      if (visible) {
        this.$EventBus.emit('globalshowLayer', this.index);
      } else {
        this.$EventBus.emit('globalhideLayer', this.index);
      }
      this.$store.dispatch('maps/toggleMapVisible', {
        mapId: this.map.id,
        visible,
      });

      track(
        FunctionIdEnum.globalLayer_layers_toggleLayersVisible,
        EventTypeEnum.CLICK,
        {
          id: this.map.id,
        },
      );
    },

    clickRefreshMapOnEarth() {
      track(
        FunctionIdEnum.globalLayer_layers_refreshLayer,
        EventTypeEnum.CLICK,
        {
          id: this.map.id,
        },
      );
      this.refreshMapOnEarth();
    },

    refreshMapOnEarth() {
      if (this.visible) {
        this.$EventBus.emit('globalrefreshLayer', this.earthLayer);
        this.$refs.mapDetailRef.recoverLayerOptions();
      }
    },

    openMapDetail() {
      this.mapDetailVisible = true;
    },
    closeMapDetail() {
      this.mapDetailVisible = false;
    },
  },
};
</script>
<style scoped>
.map-item-wrapper {
  border-bottom: 1px solid #ebeef5;
  padding-top: 8px;
  padding-bottom: 5px;
}

.map-thumb-wrapper {
  text-align: left;
}

.map-name {
  text-align: left;
}

.el-card {
  border: 1px solid #fc4c02;
  margin-top: 5px;
}

.map-item-wrapper:hover {
  background-color: #f3f6f9;
}

.author-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 7px;
  line-height: 1.5;
}
.round-img {
  border-radius: 50%;
  width: 12px;
  height: 12px;
  border: 1px solid #eee;
}
.card-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-actions {
  width: 100px;
}
.card-title {
  flex: 1;
  margin-right: 10px;
}
.el-button {
  margin: 0 5px 0 0 !important;
}
.author-left {
  display: flex;
  justify-content: center;
  align-items: center;
  .round-img {
    margin-right: 5px;
  }
}
.secondary-text {
  color: #aaa;
}

.map-by {
  background-color: #EFEFEF;
  padding: 0 4px;
  margin-right: 4px;
  line-height: 1.5;
}

.username-link {
  color: #aaa;
  text-decoration: none;
}
</style>
